import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@library';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CartModule } from '@app/modules/cart';
import { PricePipeModule } from '@library';

import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { LogoComponent } from './components/logo/logo.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ProfileComponent } from './components/profile/profile.component';
import { MenuComponent } from './components/menu/menu.component';
import { MenuMobileComponent } from './components/menu-mobile/menu-mobile.component';
import { SwitchUserComponent } from './components/switch-user/switch-user.component';
import { CartSummaryComponent } from './components/cart-summary/cart-summary.component';
import { ProfilePopoverComponent } from './components/profile-popover/profile-popover.component';

@NgModule({
    imports: [CommonModule, IconComponent, TranslateModule, RouterModule, CartModule, PricePipeModule],
    declarations: [
        AccountMenuComponent,
        LogoComponent,
        LogoutComponent,
        ProfileComponent,
        MenuComponent,
        MenuMobileComponent,
        SwitchUserComponent,
        CartSummaryComponent,
        ProfilePopoverComponent,
    ],
    exports: [
        AccountMenuComponent,
        LogoComponent,
        LogoutComponent,
        ProfileComponent,
        MenuComponent,
        MenuMobileComponent,
        SwitchUserComponent,
        CartSummaryComponent,
    ],
})
export class ShellSharedModule {}
